<template>
  <div>
    <page-title :title="$t('store.label')"/>
    <div class="l-row">
      <div class="l-col-9@md">
        <div class="l-row">
          <div v-for="definitionModule in moduleDefinitionModules" v-if="definitionModule.type !== 'tool'" class="l-col-4@md">
            <store-card :definitionModule="definitionModule"/>
          </div>
        </div>
      </div>
      <div class="l-col-3@md">
        <div class="l-row">
          <div v-for="definitionModule in moduleDefinitionModules" v-if="definitionModule.type === 'tool'" class="l-col-12@md">
            <store-card-tool :definitionModule="definitionModule"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import StoreCard from '@/components/shared/StoreCard'
  import StoreCardTool from '@/components/shared/StoreCardTool'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'

  export default {
    async mounted () {
      await this.fetch()
    },
    methods: {
      ...mapActions('module', [
        'fetch'
      ])
    },
    computed: {
      ...mapFields({
        moduleDefinitionModules: 'module.definitionModules'
      })
    },
    components: {
      Loader,
      StoreCard,
      PageTitle,
      StoreCardTool
    }
  }
</script>



// WEBPACK FOOTER //
// Base.vue?89b5500c